import React from 'react';
import { USPInformationCardsStyles as S } from './USPInformationCards.styles';
import InformationCard from '@stories/Components/Cards/InformationCard/InformationCard';
const USPInformationCards = ({ id, items, translations, }) => {
    return (React.createElement(S.Container, { id: id, innerWidth: "reduced" },
        React.createElement(S.Inner, null, items &&
            items.map((item, index) => (React.createElement(InformationCard, { key: `item-${index}`, ...item, translations: translations }))))));
};
export default USPInformationCards;
